export default __webpack_public_path__ + "static/singleLocation-cbfbdbc81a3af3983c2505ca75fa8236.png";